import { axiosIntance } from '../../../config/ApiConfig';

export const FoodCategoriesDao = {
  list: (
    accountId: string,
    page: number | string | null,
    limit: number | string | null,
    search: string | null
  ) => {
    let query = '';
    if (search) {
      query = `&filter=${search}`;
    }

    if (!page) {
      page = 1;
    }
    if (!limit) {
      limit = 20;
    }
    return axiosIntance.get(
      `/foodCategories?page=${page}&limit=${limit}&accountId=${accountId}${query}`
    );
  },
  show: (id: string) => {
    return axiosIntance.get(`/foodCategories/${id}`);
  },
  getList: (accountId: string) => {
    return axiosIntance.get(`/foodCategories/list?account=${accountId}`);
  },
  getAccountsList: () => {
    return axiosIntance.get(`/accounts/list`);
  },
};
